module.exports = __webpack_public_path__ + "img/pinterest.fc583ea9.png";